// @module Digi.SupportDocs.SupportDocs
define('IMEIManager.Collection',
    [
        'Backbone',
        'IMEIManager.Model'
    ],
    function (
        Backbone,
        IMEIManagerModel
    ) {
        'use strict';

        return Backbone.Collection.extend({
            model: IMEIManagerModel
        });
    });
